// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAfbtc } from "../../../icons/full/build/icon-afbtc.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AfbtcIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAfbtc.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AfbtcIcon.displayName = 'AfbtcIcon';
}

export default AfbtcIcon;